import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { toast } from 'sonner';
import axios from 'axios';
import { BACKEND_URL, API_BASE } from '../config/api';

const API = API_BASE;

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isVerifying, setIsVerifying] = useState(true);
  const token = searchParams.get('token');

  useEffect(() => {
    const verifyEmail = async () => {
      if (!token) {
        toast.error('Invalid verification link');
        navigate('/');
        return;
      }

      try {
        // Use GET request with token as query parameter
        const response = await axios.get(`/auth/verify-email-link?token=${token}`);
        toast.success('Email verified successfully! You can now log in.');
        setTimeout(() => navigate('/'), 2000);
      } catch (error) {
        console.error('Verification error:', error);
        const errorMessage = error.response?.data?.detail || 'Verification failed';
        toast.error(errorMessage);
        setTimeout(() => navigate('/'), 3000);
      } finally {
        setIsVerifying(false);
      }
    };

    verifyEmail();
  }, [token, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-green-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Email Verification</CardTitle>
          <CardDescription>
            {isVerifying ? 'Verifying your email...' : 'Redirecting...'}
          </CardDescription>
        </CardHeader>
        <CardContent>
          {isVerifying && (
            <div className="flex justify-center">
              <div className="animate-spin h-8 w-8 border-4 border-blue-500 border-t-transparent rounded-full"></div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default VerifyEmailPage;